<template>
<div class="WriteoffCodeList">
    <div class="bgc box-shadow title">
        <div class="classes blod">活动名称：{{$route.query.title? $route.query.title : ''}}</div>
    </div>
    <div class="filters padding-20 bgc">
        <div class="add">
            <el-button type="success" @click="handleExport">导出excel</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                <el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-input v-model="param.username" placeholder="请输入用户昵称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="orderno" label="订单号"></el-table-column>
            <el-table-column prop="customername" label="用户昵称">
                <template slot-scope="scope">
                    <div class="imgtext">
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="finalpaymoney" label="订单金额">
                 <template slot-scope="scope">
                    ￥{{scope.row.finalpaymoney}}
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="订单时间"></el-table-column>
            <el-table-column prop="ischeck" label="核销状态">
                 <template slot-scope="scope">
                    <span :class="[scope.row.ischeck?'tc-blue':'tc-red']">{{scope.row.ischeck?'已核销':'未核销'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="checkusername" label="核销员">
                <template slot-scope="scope">
                    {{scope.row.checkusername?scope.row.checkusername: '-'}}
                </template>
            </el-table-column>
            <el-table-column prop="checktime" label="核销时间" class-name="right">
                <template slot-scope="scope">
                    {{scope.row.checktime?scope.row.checktime: '-'}}
                </template>
            </el-table-column>
        </el-table>
        <dialogPage :total="total" @getList="_getList" ref="dialogPage"></dialogPage>
    </div>
</div>
</template>

<script>
import {getDisEventCheckPageList, exportCheckPageList} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import DialogPage from 'base/page/dialogPage'
export default {
    name: 'WriteoffCodeList',
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
                status: '',
                username: ''
            },
            statusList: [
                {code: '', name: '全部状态'},
                {code: '0', name: '未核销'},
                {code: '1', name: '已核销'}
            ],
            tableData: [],
            total: 0
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleQuery() {
            this._getList()
        },
        handleExport() {
            this.setLoading(true)
            exportCheckPageList({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '核销列表' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getDisEventCheckPageList({
                data: Object.assign({}, this.param, this.dialogPage),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'dialogPage',
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        DialogPage
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.WriteoffCodeList {
    .title{
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        border-bottom: 1px solid $line;
        .classes{
            margin-bottom: 0;
        }
        .el-input__icon{
            line-height: 1;
        }
    }
    .result-list{
        padding: 10px 20px;
    }
    .imgtext{
        display: flex;
        align-items: center;
        img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .right{
        .cell{
            text-align: right;
        }
    }
    .filters{
        margin: 0;
    }
}
</style>
